module.exports = __webpack_public_path__ + "static/media/banner-right-image.80a608db.png";